import React from "react";
import Highcharts from "highcharts";
import Highcharts3D from "highcharts/highcharts-3d";
import HighchartsReact from "highcharts-react-official";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import { useSelector } from "react-redux";

// if (typeof Highcharts === "object") {
//   Highcharts3D(Highcharts);
// }

const DoughnutChart = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();
  const { data: generationChart = [], isLoading: announcementsIsLoading } =
    useGetProtectedApiDataQuery({
      url: "neepco_power_generation_chart",
      lang: languageType,
    });

  const transformedData = generationChart.map((item) => {
    return [item.title, parseInt(item.field_chart_pwoer_capacity_mw)];
  });

  const totalCapacity = transformedData.reduce((sum, item) => sum + item[1], 0);

  console.log(totalCapacity);

  const getAccessibleSummary = () => {
    return transformedData
      .map((item) => {
        const percentage = ((item[1] / totalCapacity) * 100).toFixed(1);
        return `${item[0]}: ${item[1]} MW (${percentage}%)`;
      })
      .join(", ");
  };

  const data = [...transformedData];

  const options = {
    chart: {
      type: "pie",
      height: 400,
      options3d: {
        enabled: true,
        alpha: 35,
        beta: 0,
        depth: 100,
        viewDistance: 100,
      },
    },
    title: {
      text: getText("NEEPCO Power Generation", "नीपको बिजली उत्पादन चार्ट"),
      align: "center",
      marginTop: 16,
    },
    plotOptions: {
      pie: {
        innerSize: "40%",
        depth: 45,
        dataLabels: {
          enabled: true,
          format: "{point.name}: {point.y:.1f} ",
        },
      },
    },
    tooltip: {
      formatter: function () {
        return `
        <b>${this.point.name}</b><br/>
        <b>${this.point.y.toLocaleString()} MW</b><br/>
      `;
      },
      useHTML: true,
    },
    series: [
      {
        data: data,
      },
    ],
  };

  if (announcementsIsLoading) {
    return <div>Loading...</div>; // Loading state
  }
  return (
    <a className="cursor-none" href="javascript:void()">
      <details className="sr-only">
        <summary>Power Generation Chart Data Summary</summary>
        <p>
          This doughnut chart shows NEEPCO's power generation capacity by
          source:
        </p>
        <ul>
          <li>Total capacity: 2027 MW</li>
          {/* {transformedData.map((item, index) => (
            <li key={index}>
              {item[0]}: {item[1]} MW (
              {((item[1] / totalCapacity) * 100).toFixed(1)}%)
            </li>
          ))} */}
          <li>Solar Power : 0.2% 5 MW</li>
          <li>Thermal Power : 25.6% 527 MW</li>
          <li>Hydro Power : 74.1% 1525 MW</li>
        </ul>
      </details>
      <div
        className="performance-generation-sec h-100 wow zoomIn pt-2"
        aria-label={`NEEPCO Power Generation breakdown: ${getAccessibleSummary()}`}
      >
        <HighchartsReact highcharts={Highcharts} options={options} />

        <div className="visually-hidden">
          <p>
            Interactive 3D doughnut chart showing power generation capacity by
            source.
          </p>
          {/* <p>
            Hover over segments to see detailed values or view the legend for
            color coding.
          </p> */}
        </div>
      </div>
    </a>
  );
};

export default DoughnutChart;
